import React, { useState, useRef, useEffect } from "react";
import "./Fading.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function MultipleImages(props) {
  const [isVisible, setVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => setVisible(entry.isIntersecting));
    });
    observer.observe(domRef.current);
    return () => observer.unobserve(domRef.current); // Cleanup
  }, []);

  const width = window.innerWidth;

  const mediaDimensions = {
    width: props.isMobile ? '80vw' : '500px',
    height: props.isMobile ? 'auto' : '300px',
    overflowX: "hidden",
    overflowY: "hidden",
  };

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection: width >= 1200 ? "row" : "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "black",
        padding: width >= 1200 ? "1vh 15vw 1vh 15vw" : "0vh 0vw 0vh 0vw",
        margin: props.isMobile? "0vh 0vw":"0vh 10vw",
        overflowX: "hidden",
        overflowY: "hidden",
        //outline: "#4CAF50 solid 5px",
      }}>
      {props.multipleImages.split("\r\n\r\n").map((s, i) => (
        <div key={i} ref={domRef}>
          <div
            style={{ padding: props.isMobile? "0vh 0vw 0vh 0vw":"0vh 0vw 0vh 2vw", ...mediaDimensions }}>
            {s.startsWith(" VIDEO:") ? (
              <div
              className={`fade-in-section ${isVisible ? 'is-visible' : ''}`}>
              <video
                src={s.replace(" VIDEO:", "")}
                muted={true}
                loop={true}
                autoPlay={true}
                playsInline={true}
                style={{ 
                  width: props.isMobile?"100%":"100%", 
                  height: props.isMobile?"auto":"100%", 
                  objectFit: "cover", 
                }}>
              </video>
              </div>
            ) : (
              props.isMobile? 
              (
              <div>
              <LazyLoadImage
                src={s}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                alt="description of media"
              />
              </div> 
              ):
              (
                <div
                className={`fade-in-section ${isVisible ? 'is-visible' : ''}`}>
              <LazyLoadImage
                src={s}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                alt="description of media"
              />
              </div>)
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
